import styled from 'styled-components'

export const DeliveryDetailContainer = styled.div`
  background-color: white;
  margin-bottom: 10px;
  padding: 10px 15px;
`